import { LoaderStyled } from './Loader.styled';

export default function Loader() {
  return <LoaderStyled />;
}
